/* eslint-disable max-lines-per-function */
import "./contactus-late-order.scss";

const toggleOrderInfo = () => {
  const $toggles = document.querySelectorAll(".js-late-order-toggle-order-info");

  $toggles.forEach($element => {
    const $toggle = $element;
    $toggle.addEventListener("click", () => {
      $toggle.classList.toggle("show-info");
      $toggle.ariaExpanded = !($toggle.ariaExpanded === "true");
    });
  });
};

const validateShipmentsSelection = () => {
  const checkboxes = document.querySelectorAll(".js-late-order-shipments-option");
  const customOrderTextarea = document.querySelector(".js-late-order-custom-order");
  const checkboxesSelected = [];
  const countSelectedCheckboxes = () => checkboxesSelected.reduce((acc, curr) => acc + curr, 0);
  const requiredCheckbox = required => {
    checkboxes.forEach(checkbox => {
      if (required && customOrderTextarea.value === "") {
        checkbox.setAttribute("required", "required");
      } else {
        checkbox.removeAttribute("required");
      }
    });
  };

  customOrderTextarea.addEventListener("keydown", event => {
    setTimeout(() => {
      requiredCheckbox(event.target.value === "");
    }, 10);
  });

  checkboxes.forEach((checkbox, idx) => {
    checkbox.addEventListener("change", () => {
      checkboxesSelected[idx] = checkbox.checked;
      requiredCheckbox(countSelectedCheckboxes() === 0);
    });
  });
};

export default () => {
  toggleOrderInfo();
  validateShipmentsSelection();
};
